import { useApi } from '../api/client.js';
import { Card } from '../components/ui.js';
import { useAsync } from '../hooks/useAsync.js';

export function HoneypotSparkline() {
  const api = useApi();
  const { state } = useAsync(() => api.honeypotSeries(14), [api]);

  if (state.status === 'loading') {
    return (
      <Card title="Honeypot effectiveness">
        <div className="h-[80px] animate-pulse" style={{ background: 'var(--bg-secondary)' }} />
      </Card>
    );
  }
  if (state.status === 'error') {
    return (
      <Card title="Honeypot effectiveness">
        <div role="alert" style={{ color: 'var(--danger-text)' }}>
          {state.error.message}
        </div>
      </Card>
    );
  }

  const data = state.data;
  const max = Math.max(1, ...data.map((d) => d.count));
  const start = data[0]?.date ?? '';
  const end = data[data.length - 1]?.date ?? '';
  const total = data.reduce((a, d) => a + d.count, 0);
  const firstHalf = data.slice(0, Math.floor(data.length / 2)).reduce((a, d) => a + d.count, 0);
  const secondHalf = total - firstHalf;
  const trend = secondHalf > firstHalf ? '↗ rising' : secondHalf < firstHalf ? '↘ falling' : '→ steady';

  return (
    <Card title="Honeypot effectiveness">
      <svg
        role="img"
        aria-label={`Daily honeypot hits from ${start} to ${end}; total ${total}, trend ${trend}`}
        viewBox={`0 0 ${data.length * 10} 80`}
        className="w-full h-20"
      >
        {data.map((d, i) => {
          const h = Math.round((d.count / max) * 76) || 2;
          return (
            <rect
              key={d.date}
              x={i * 10 + 1}
              y={80 - h}
              width={8}
              height={h}
              fill="var(--accent)"
              rx={1}
            />
          );
        })}
      </svg>
      <div
        className="flex justify-between text-[12px] mt-2"
        style={{ color: 'var(--text-secondary)' }}
      >
        <span>{start}</span>
        <span>{trend}</span>
        <span>{end}</span>
      </div>
    </Card>
  );
}
